import { render, staticRenderFns } from "./AddBankScreen.vue?vue&type=template&id=3c33b15a&scoped=true&"
import script from "./AddBankScreen.vue?vue&type=script&lang=js&"
export * from "./AddBankScreen.vue?vue&type=script&lang=js&"
import style0 from "./AddBankScreen.vue?vue&type=style&index=0&id=3c33b15a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c33b15a",
  null
  
)

export default component.exports